import en from './en'
import zhHant from './zh-Hant'

export default {
  en,
  'zh-Hant': zhHant,
}
